import { useEffect, useState } from 'react';

const useDeviceWidth = (): number => {
  const isClient = process.env.JS_ENV_CLIENT !== 'undefined';

  const [width, setWidth] = useState<number>(process.env.JS_ENV_CLIENT ? window.innerWidth : 0);

  useEffect(() => {
    if (!isClient) {
      return;
    }

    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    handleResize();

    // eslint-disable-next-line consistent-return
    return () => window.removeEventListener('resize', handleResize);
  }, [isClient]);

  return width;
};

export default useDeviceWidth;
